import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { msgid, ngettext, t } from 'ttag'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { FormData } from '../../ChallengeAdmin'
import { ReactComponent as DateActiveIcon } from '../../../../assets/v3/icons/date-active.svg'
import { ReactComponent as DateInactiveIcon } from '../../../../assets/v3/icons/date-inactive.svg'

interface ChallengeMaxManualEntryDaysProps {
  control: Control<FormData>
}

export default function ChallengeMaxManualEntryDays(props: ChallengeMaxManualEntryDaysProps) {
  const { control } = props
  const options = Array.from({ length: 31 }, (_, index) => index + 1)

  return (
    <>
      <Controller
        name="maxManualEntryDays"
        rules={{
          required: true,
        }}
        control={control}
        render={({ field: { ref, onChange, ...otherField } }) => (
          // @ts-ignore
          <YumSelect
            label={t`Max manual entry days`}
            startIcon={DateInactiveIcon}
            style={{ marginBottom: 10 }}
            onChange={(e) => onChange(Number(e.target.value))}
            {...otherField}
          >
            {options.map((number) => (
              <option key={number} value={number}>
                {number} {ngettext(msgid`day`, `days`, number)}
              </option>
            ))}
          </YumSelect>
        )}
      />
    </>
  )
}
